import loadImage from 'node_modules/blueimp-load-image/js/index.js';
import MobileDetect from "mobile-detect";

export default class ImageUploaderService {
	constructor(selector, limit) {
		this.uploader = document.querySelector(selector);
		this.limit = limit;
		this.button = this.uploader.querySelector('.btn-image-upload');
		this.input = this.createFileInput();
		this.errorTimeout = null;

		this.init();
	}

	init() {
		this.button.addEventListener('click', () => this.input.click());
		this.input.addEventListener('change', () => this.handleFiles(this.input.files));
		this.setupDragEvents();
		this.setupRemoveImageListener();
		this.prepareCapture();
	}

	prepareCapture() {
		this.captureButton = this.uploader.querySelector('.btn-take-photo');

		const md = new MobileDetect(window.navigator.userAgent);
		console.log('md', md.phone());

		if (md.phone() !== null) {
			this.captureButton.classList.remove('d-none');
			this.capture = this.createCaptureInput();
			this.captureButton.addEventListener('click', () => this.capture.click());
			this.capture.addEventListener('change', () => this.handleFiles(this.capture.files));
		} else {
			this.captureButton.classList.add('d-none');
		}
	}

	createFileInput() {
		const input = document.createElement('input');
		input.type = 'file';
		input.multiple = true;
		input.accept = '.jpg, .png, .bmp';
		return input;
	}

	createCaptureInput() {
		const input = document.createElement('input');
		input.type = 'file';
		input.multiple = true;
		input.capture = 'environment';
		input.accept = 'image/*';
		input.id = 'capture-input';
		return input;
	}

	setupRemoveImageListener() {
		this.uploader.addEventListener('click', (event) => {
			if (event.target.closest('.remove')) {
				event.preventDefault();
				this.removeImage(event.target);
			}
		});
	}

	addImage(src, name = '') {
		if (this.uploader.querySelectorAll('.item').length >= this.limit) {
			this.showError('limit');
			return;
		}

		const el = document.createElement('div');
		el.className = 'item';
		el.innerHTML = `
			<span class="remove"><i aria-hidden="true" class="ri-delete-bin-line"></i></span>
			<div class="image"><img src="${src}" alt="${name}" /></div>
			<textarea name="captions[]" placeholder="${this.uploader.dataset.captionPlaceholder}" rows="2"></textarea>
			<input type="hidden" name="photos[]" value="${src}" />
		`;

		this.uploader.querySelector('content').appendChild(el);

		if (this.uploader.querySelectorAll('.item').length > 0) {
			this.uploader.classList.remove('closed');
		}
	}

	removeImage(el) {
		const item = el.closest('.item');
		if (item) {
			item.remove();
		}

		if (this.uploader.querySelectorAll('.item').length === 0) {
			this.uploader.classList.add('closed');
		}
	}

	showError(type) {
		if (this.errorTimeout) {
			clearTimeout(this.errorTimeout);
		}

		const box = this.uploader.querySelector(`.error-text.type-${type}`);
		if (box) {
			box.style.display = 'block';
			this.errorTimeout = setTimeout(() => {
				box.style.display = 'none';
			}, 4000);
		}
	}

	handleFiles(files) {
		if (files.length) {
			let finished = 0;
			this.uploader.querySelector('.processing').style.display = 'block';

			Array.from(files).forEach(file => {
				if (file.type.split('/')[0] !== 'image') return;

				loadImage.parseMetaData(file, data => {
					const options = {
						maxWidth: 2000,
						maxHeight: 2000,
						canvas: true,
						meta: true,
						parseMetaData: true
					};

					if (data.exif && data.exif.get('Orientation')) {
						options.orientation = data.exif.get('Orientation');
					}

					loadImage(file, canvas => {
						finished++;
						this.addImage(canvas.toDataURL('image/jpeg', 0.95), file.name);

						if (finished >= files.length) {
							this.uploader.querySelector('.processing').style.display = 'none';
						}
					}, options);
				});
			});
		}
	}

	setupDragEvents() {
		['dragenter', 'dragover', 'dragleave', 'drop'].forEach(type => {
			this.uploader.addEventListener(type, event => {
				event.preventDefault();
				event.stopPropagation();

				if (type === 'dragenter' || type === 'dragover') {
					this.uploader.classList.add('on-drag');
				} else if (type === 'dragleave' || type === 'drop') {
					this.uploader.classList.remove('on-drag');
				}

				if (type === 'drop') {
					this.handleFiles(event.dataTransfer.files);
				}
			});
		});
	}
}

// Usage example
// document.addEventListener('DOMContentLoaded', () => {
// 	new ImageUploaderService('.image-uploader-selector', 10);
// });